import { render, staticRenderFns } from "./Vaccines.vue?vue&type=template&id=5a26f302&scoped=true&lang=pug&"
import script from "./Vaccines.vue?vue&type=script&lang=js&"
export * from "./Vaccines.vue?vue&type=script&lang=js&"
import style0 from "./Vaccines.vue?vue&type=style&index=0&id=5a26f302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a26f302",
  null
  
)

export default component.exports